// Rating series: each item is a separate ranking computed from tournaments
// whose start_date falls in [startDate, endDateExclusive). Add new entries
// at the top of the array — the first item is treated as the current series.
export interface RatingSeries {
  id: string;
  label: string;
  startDate: string;        // inclusive, YYYY-MM-DD
  endDateExclusive: string; // exclusive, YYYY-MM-DD
}

export const RATING_SERIES: RatingSeries[] = [
  { id: 'november-2026', label: 'Ноябрьская серия', startDate: '2026-11-01', endDateExclusive: '2026-12-01' },
  { id: 'october-2026', label: 'Октябрьская серия', startDate: '2026-10-01', endDateExclusive: '2026-11-01' },
  { id: 'september-2026', label: 'Сентябрьская серия', startDate: '2026-09-01', endDateExclusive: '2026-10-01' },
  { id: 'august-2026', label: 'Августовская серия', startDate: '2026-08-01', endDateExclusive: '2026-09-01' },
  { id: 'july-2026',  label: 'Июльская серия',   startDate: '2026-07-01', endDateExclusive: '2026-08-01' },
  { id: 'june-2026',  label: 'Июньская серия',   startDate: '2026-06-01', endDateExclusive: '2026-07-01' },
  { id: 'may-2026',   label: 'Майская серия',    startDate: '2026-05-06', endDateExclusive: '2026-06-01' },
  { id: 'april-2026', label: 'Апрельская серия', startDate: '2026-04-01', endDateExclusive: '2026-05-04' },
];

export function getCurrentSeries(): RatingSeries {
  return RATING_SERIES[0];
}

// MPT series: same mechanics as RATING_SERIES, but the ranking is built only
// from tournaments flagged is_mpt. Ranges are independent of calendar months.
// Add new entries at the top — the first is the current MPT series.
export const MPT_SERIES: RatingSeries[] = [
  // Two-month series: October + November.
  { id: 'mpt-october-2026', label: 'MPT · Октябрь–Ноябрь 2026', startDate: '2026-10-01', endDateExclusive: '2026-12-01' },
  { id: 'mpt-september-2026', label: 'MPT · Сентябрь 2026', startDate: '2026-09-01', endDateExclusive: '2026-10-01' },
  { id: 'mpt-august-2026', label: 'MPT · Август 2026', startDate: '2026-08-01', endDateExclusive: '2026-09-01' },
];
